export default __webpack_public_path__ + "static/media/logo-pack-vip.4cb218f5.svg";